const ROUTE_PATHS = {
  // --- LOGIN ----
  LOGIN: "/",
  // ---- Dashboard Route ----
  DASHBOARD: "/app",

  // ---- Consignment Routes ----
  CONSIGNMENT: "/app/consignment",

  // ---- Shipping Statuses Routes ----
  SHIPMENT_STATUS: "/app/shipment-status",

  // ---- Container Types Routes ----
  CONTAINER_TYPE: "/app/container-type",

  // ---- Descriptions Routes ----
  DESCRIPTIONS: "/app/descriptions",

  // ---- Port Routes ----
  PORT: "/app/port",

  // ---- Shipper Routes ----
  SHIPPER: "/app/shipper",

  // ---- Vendor Routes ----
  VENDOR: "/app/vendor",

  // ---- Shipping Line Routes ----
  SHIPPING_LINE: "/app/shipping-line",

  // ---- Vessel Routes ----
  VESSEL: "/app/vessel",

  // ---- Container Routes ----
  CONTAINER: "/app/container",

  // ---- Invoice Particular Routes ----
  INVOICE_PARTICULAR: "/app/invoice-particular",

  // ---- Invoice Routes ----
  INVOICE: "/app/invoice",
  CREATE_INVOICE: "/app/invoice/create",
  INVOICE_PREVIEW: "/app/invoice/preview/:id",

  // ---- Customer Routes ----
  CUSTOMER: "/app/customer"
}

export default ROUTE_PATHS
